export const FETCH_ARTICLE_ERROR = 'Oh no! We had trouble pulling in this url. Try adding a title below and clicking add article.'
export const ADD_ARTICLE_ERROR = 'Oh no, we were unable to save that article.  We have been notified of the error.'
